import connectAsync from '../../../utils/connectAsync';
import DataRequestConfirmationRoute from './DataRequestConfirmationRoute';
import { fetchMe } from './../../../actions/me';

export default connectAsync([fetchMe])(DataRequestConfirmationRoute);
